module.exports = __webpack_public_path__ + "media/sub7-3-4.bf127d49.mp4";